var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.message
    ? _c("div", { staticClass: "uk-position-top" }, [
        _c(
          "div",
          {
            class:
              _vm.message.type == "error"
                ? "uk-alert-danger"
                : "uk-alert-success",
            attrs: { "uk-alert": "" }
          },
          [
            _c("a", {
              staticClass: "uk-alert-close",
              attrs: { "uk-close": "" }
            }),
            _c("div", [_vm._v(_vm._s(_vm.message.text))])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }